// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-terapije {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280a;
  border-radius: 8px;
  background-color: white;
  min-width: fit-content;
}
.table-terapije th,
.table-terapije td {
  padding: 32px;
  border-bottom: 1px solid #d1d9e2;
}
.table-terapije td {
  padding: 32px 32px 32px 48px;
}

.table-terapije tr:last-child {
  border-bottom: none;
}

.table-terapije th,
.table-terapije tr {
  text-align: left;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #5f6d7e;
}
.table-terapije th {
  background-color: #f8f9fb;
  padding: 16px 16px 16px 48px;
}
.table-terapije tr {
  font-weight: 500;
}
.table-terapije-btn,
.table-terapije-btn:disabled {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  padding: 8px;
}
.table-terapije-btn {
  background-color: #cb2d2d;
  border: none;
  cursor: pointer;
}
.table-terapije-btn:disabled {
  background-color: #6d7175;
  cursor: not-allowed;
  pointer-events: none;
}
.table-terapije-btn:hover {
  background-color: #8f1c1c;
}
.table-terapije-trash-icon {
  width: 24px;
  height: 24px;
}

@media screen and (max-width: 500px) {
  .table-terapije {
    margin-left: 400px;
  }
}

@media screen and (min-width: 501px) and (max-width: 880px) {
  .table-terapije {
    margin-left: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/TerapijeModal/Table/TableTerapije.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".table-terapije {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 10px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280a;\n  border-radius: 8px;\n  background-color: white;\n  min-width: fit-content;\n}\n.table-terapije th,\n.table-terapije td {\n  padding: 32px;\n  border-bottom: 1px solid #d1d9e2;\n}\n.table-terapije td {\n  padding: 32px 32px 32px 48px;\n}\n\n.table-terapije tr:last-child {\n  border-bottom: none;\n}\n\n.table-terapije th,\n.table-terapije tr {\n  text-align: left;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0em;\n  color: #5f6d7e;\n}\n.table-terapije th {\n  background-color: #f8f9fb;\n  padding: 16px 16px 16px 48px;\n}\n.table-terapije tr {\n  font-weight: 500;\n}\n.table-terapije-btn,\n.table-terapije-btn:disabled {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  padding: 8px;\n}\n.table-terapije-btn {\n  background-color: #cb2d2d;\n  border: none;\n  cursor: pointer;\n}\n.table-terapije-btn:disabled {\n  background-color: #6d7175;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.table-terapije-btn:hover {\n  background-color: #8f1c1c;\n}\n.table-terapije-trash-icon {\n  width: 24px;\n  height: 24px;\n}\n\n@media screen and (max-width: 500px) {\n  .table-terapije {\n    margin-left: 400px;\n  }\n}\n\n@media screen and (min-width: 501px) and (max-width: 880px) {\n  .table-terapije {\n    margin-left: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
